import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { flow } from 'lodash'
import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppState } from 'store'

export interface IClientProfileContactCalloutState {
  showCallout?: boolean
  error?: Error
}

const { actions, reducer } = createSlice({
  name: 'useClientProfileContactCallout',
  initialState: {} as IClientProfileContactCalloutState,
  reducers: {
    show: () => ({
      showCallout: true
    }),
    hide: () => ({
      showCallout: false,
      error: undefined
    }),
    failure: (state, action: PayloadAction<Error>) => ({
      ...state,
      error: action.payload
    })
  }
})

const clientProfileContactRootSelector = (state: AppState) =>
  state.modules.advisory.modules.rdot360.createClientProfileContactCallout

const getShouldShowCallout = flow(
  clientProfileContactRootSelector,
  (x) => x.showCallout
)
const getPanelError = flow(clientProfileContactRootSelector, (x) => x.error)
export const useClientProfileContactCallout = () => {
  const dispatch = useDispatch()

  const hide = useCallback(() => {
    dispatch(actions.hide())
  }, [dispatch])

  const show = useCallback(() => {
    dispatch(actions.show())
  }, [dispatch])

  const setError = useCallback(
    (e: Error) => {
      dispatch(actions.failure(e))
    },
    [dispatch]
  )

  const showCallout = useSelector(getShouldShowCallout)

  const error = useSelector(getPanelError)

  return {
    hide,
    show,
    setError,
    showCallout,
    error
  }
}

export { reducer as createClientProfileContactCalloutReducer }
